import styled from 'styled-components';

const cardMergeStyled = styled.div`
  .merge-content-wrap {
    margin: 21px 0;
    position: relative;
    display: flex;
    flex-direction: row;
    gap: 3px;
    .secondary-card-wrap {
      border: ${(props) =>
        props.isHasSecondaryCard ? '1px solid #212121' : ''};
    }
    .admin-card-wrap {
      border: ${(props) => (props.isHasAdminCard ? '1px solid #1565C0' : '')};
    }
    .admin-card-wrap,
    .secondary-card-wrap {
      width: 50%;
      padding: 24px 27px;
      background: #ffffff;
      box-shadow: 0px 0px 4px 0px rgba(181, 181, 181, 0.26);
      border-radius: 10px;
      .admin-title,
      .secondary-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 23px;
        span {
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 21px;
          margin-left: 14px;
        }
      }
      .admin-title {
        color: #1565c0;
      }
      .secondary-title {
        color: #212121;
      }
      .admin-card-content {
        padding: 24px 27px;
        background: #f9f9f9;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        /* flex-wrap: wrap; */
        /* justify-content: space-between; */
        gap: 25px;
        margin-top: 5px;
        .card-content-top {
          display: flex;
          flex-direction: row;
          /* flex-wrap: wrap; */
          justify-content: space-between;
          width: 100%;
        }
        span {
          font-size: 12px;
          font-weight: 400;
          color: #6a6a6a;
          line-height: 10px;
        }
        div {
          width: 50%;
          /* min-width: 295px; */
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 21px;
        }
      }
      .reset-btn-admin,
      .reset-btn-secondary {
        float: right;
        margin-top: 30px;
        font-size: 18px;
      }
      .reset-btn-secondary {
        color: ${(props) => (props.isHasSecondaryCard ? '#212121' : '#BDBDBD')};
      }
      .reset-btn-admin {
        color: ${(props) => (props.isHasAdminCard ? '#212121' : '#BDBDBD')};
      }
    }
    .trans-btn {
      position: absolute;
      width: 48px;
      height: 48px;
      /* background: #1565c0; */
      border-radius: 50%;
      left: 0;
      right: 0;
      margin: auto;
      top: 42%;
      /* cursor: pointer; */
      cursor: ${(props) =>
        props.isHasAdminCard || props.isHasSecondaryCard
          ? 'pointer'
          : 'not-allowed'};
      z-index: 11;
    }
  }
  .merge-reason-wrap {
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(181, 181, 181, 0.26);
    border-radius: 10px;
    padding: 21px 0 123px 27px;
    .single-select {
      min-width: 309px;
    }
  }
  .submit-btn-wrap {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(181, 181, 181, 0.26);
    border-radius: 10px;
    padding: 21px 27px;
    margin-top: 4px;
    .btn-wrap {
      display: flex;
      flex-direction: row;
      gap: 14px;
    }
  }
  .error-wrap-admin {
    position: absolute;
    bottom: 0;
    right: 27px;
  }
  .error-wrap-second {
    position: absolute;
    bottom: 0;
    left: 27px;
  }
`;
export default cardMergeStyled;
